var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSuitcase, faCaretRight, faCaretDown, faPencil, faCheck, faUndo, faTrash, faSave, } from "@fortawesome/free-solid-svg-icons";
import { faCopy } from "@fortawesome/pro-solid-svg-icons";
import { Button } from "@mui/joy";
import toast from "react-hot-toast";
import { useSaveUserPreferencesMutation } from "@/store/api";
import { LoaderImage } from "@/utils/loader";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "@/hooks/store";
import { getUserPreferences } from "@/store/utils/selectors/userSelector";
import { useTranslation } from "react-i18next";
var ViewManager = function (_a) {
    var module = _a.module, config = _a.config, initialConfigRef = _a.initialConfigRef, onPageChange = _a.onPageChange, onSetColumnsState = _a.onSetColumnsState, onSetFiltersSelected = _a.onSetFiltersSelected, onSetFrozenFieldState = _a.onSetFrozenFieldState, 
    //onSetTotalFreezeRows,
    onSetElementCountPerPage = _a.onSetElementCountPerPage;
    var _b = useState([]), listViewSettings = _b[0], setListViewSettings = _b[1];
    var _c = useState([]), selectedListView = _c[0], setSelectedListView = _c[1];
    var t = useTranslation(["common", module]).t;
    var _d = useState(false), isLabelViewOnOver = _d[0], setIsLabelViewOnOver = _d[1];
    var defaultViewname = t("app.LBL_ALL");
    var _e = useState(defaultViewname), viewname = _e[0], setViewname = _e[1];
    var _f = useState(t("app.LBL_SAVE_VIEW")), saveViewname = _f[0], setsaveViewname = _f[1];
    var _g = useState(false), isClicked = _g[0], setIsClicked = _g[1];
    var _h = useState(false), isMoreViewClicked = _h[0], setIsMoreViewClicked = _h[1];
    var _j = useState(false), isSaveChoice = _j[0], setIsSaveChoice = _j[1];
    var _k = useState(false), isEdited = _k[0], setIsEdited = _k[1];
    var _l = useState(false), isNewView = _l[0], setIsNewView = _l[1];
    var inputRef = useRef(null);
    var dropdownInputRef = useRef(null);
    var dropdownSaveRef = useRef(null);
    var _m = useSaveUserPreferencesMutation(), saveUserPreferences = _m[0], _o = _m[1], saveData = _o.data, tokenAccessError = _o.error, isLoadSave = _o.isLoading;
    //const { data: queryUserResult } = useGetCurrentUserQuery(null);
    var userPreferences = useAppSelector(getUserPreferences);
    var uuidv4 = require("uuid").v4;
    var id = uuidv4();
    var _p = useState([
        { id: "all", label: defaultViewname },
    ]), listViewName = _p[0], setListViewName = _p[1];
    var _q = useState([
        { value: "savecopie", label: t("app.LBL_SAVE_VIEW_COPY") },
        { value: "cancelmodif", label: t("app.LBL_UNDO_CHANGE") },
        { value: "deleteview", label: t("app.LBL_REMOVE_VIEW") },
    ]), listSaveconfig = _q[0], setListSaveconfig = _q[1];
    var _r = useState([]), dataList = _r[0], setDataList = _r[1];
    var getViewNameListSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
        var list, result_1;
        return __generator(this, function (_a) {
            //if (queryUserResult?.data?.preferences?.viewlist_settings) {
            //const list = queryUserResult?.data?.preferences?.viewlist_settings;
            if (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.viewlist_settings) {
                list = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.viewlist_settings;
                result_1 = [];
                list.forEach(function (settings) {
                    if (settings[module]) {
                        settings[module].forEach(function (item) {
                            result_1.push({ id: item.id, label: item.viewname });
                        });
                    }
                });
                setListViewName(result_1);
            }
            return [2 /*return*/];
        });
    }); };
    var processViewListSettings = function () {
        if (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.viewlist_settings) {
            var list = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.viewlist_settings;
            var result_2 = [];
            list.forEach(function (settings) {
                if (settings[module]) {
                    settings[module].forEach(function (item) {
                        result_2.push({ id: item.id, label: item.viewname });
                    });
                }
            });
            return result_2;
        }
        return [];
    };
    var getViewNameListSettingsSelected = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, defaultView;
        return __generator(this, function (_a) {
            result = processViewListSettings();
            defaultView = result.find(function (item) { return item.id === selectedListView.id; });
            if (defaultView) {
                setViewname(defaultView.label);
                setListViewName(function (prevListViewName) {
                    return prevListViewName.map(function (item) {
                        return item.id === defaultView.id ? defaultView : item;
                    });
                });
            }
            else {
                setViewname(defaultViewname);
            }
            return [2 /*return*/];
        });
    }); };
    var getViewListSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
        var list, result_3;
        return __generator(this, function (_a) {
            //if (queryUserResult?.data?.preferences?.viewlist_settings) {
            //const list = queryUserResult?.data?.preferences?.viewlist_settings;
            if (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.viewlist_settings) {
                list = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.viewlist_settings;
                result_3 = [];
                list.forEach(function (settings) {
                    if (settings[module]) {
                        result_3.push.apply(result_3, settings[module]);
                    }
                });
                setListViewSettings(result_3);
            }
            return [2 /*return*/];
        });
    }); };
    var getAllData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var list;
        return __generator(this, function (_a) {
            //if (queryUserResult?.data?.preferences?.viewlist_settings) {
            //  const list = queryUserResult?.data?.preferences?.viewlist_settings;
            if (userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.viewlist_settings) {
                list = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.viewlist_settings;
                setDataList(list);
            }
            return [2 /*return*/];
        });
    }); };
    var displayConfig = function (configData) {
        var _a;
        onSetColumnsState(configData === null || configData === void 0 ? void 0 : configData.columns);
        onSetFiltersSelected(configData === null || configData === void 0 ? void 0 : configData.filters);
        onSetFrozenFieldState(configData === null || configData === void 0 ? void 0 : configData.freezeColumns);
        //onSetTotalFreezeRows([module, configData?.freezeRows]);
        onSetElementCountPerPage((_a = configData === null || configData === void 0 ? void 0 : configData.paginations) === null || _a === void 0 ? void 0 : _a.elementPerPage);
    };
    useEffect(function () {
        var _a;
        var moduleObject = dataList.find(function (item) { return item[module]; });
        // Find the selected item in the module array
        var selectedViewByDefault = (_a = moduleObject === null || moduleObject === void 0 ? void 0 : moduleObject[module]) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.selected; });
        if (selectedViewByDefault) {
            displayConfig(selectedViewByDefault === null || selectedViewByDefault === void 0 ? void 0 : selectedViewByDefault.config);
            onPageChange(selectedViewByDefault === null || selectedViewByDefault === void 0 ? void 0 : selectedViewByDefault.config.paginations.currentPage);
            setViewname(selectedViewByDefault === null || selectedViewByDefault === void 0 ? void 0 : selectedViewByDefault.viewname);
            setSelectedListView(selectedViewByDefault);
        }
    }, [dataList, module]);
    useEffect(function () {
        getViewNameListSettings();
        getViewListSettings();
        getAllData();
    }, [module]);
    var validateViewname = function () {
        setIsClicked(false);
        setIsEdited(false);
        if (isViewListAlreadyExists(viewname) && isNewView) {
            setIsClicked(true);
            toast.error("".concat(t("app.LBL_SORRY"), " ").concat(viewname, " ").concat(t("app.LBL_ALREADY_EXIST")));
            deleteView(selectedListView === null || selectedListView === void 0 ? void 0 : selectedListView.id, selectedListView === null || selectedListView === void 0 ? void 0 : selectedListView.viewname);
        }
        else if (viewname === "" && isNewView) {
            setIsClicked(true);
            toast.error(t("app.LBL_SORRY_VIEW_EXIST"));
            deleteView(selectedListView === null || selectedListView === void 0 ? void 0 : selectedListView.id, selectedListView === null || selectedListView === void 0 ? void 0 : selectedListView.viewname);
        }
        else {
            var selectedListViewSettings = listViewSettings.find(function (item) { return item.viewname === viewname; });
            selectedListViewSettings && setSelectedListView(selectedListViewSettings);
            var updatedListView = listViewSettings &&
                listViewSettings.map(function (item, index) {
                    if ((item === null || item === void 0 ? void 0 : item.id) === (selectedListView === null || selectedListView === void 0 ? void 0 : selectedListView.id)) {
                        return __assign(__assign({}, item), { viewname: viewname.trim() });
                    }
                    return item;
                });
            // Update listViewSettings state
            setListViewSettings(updatedListView);
            // Update listViewName state
            var updatedListViewNames = listViewName &&
                listViewName.map(function (item) {
                    return (item === null || item === void 0 ? void 0 : item.id) === (selectedListView === null || selectedListView === void 0 ? void 0 : selectedListView.id)
                        ? { id: item.id, label: viewname.trim() }
                        : item;
                });
            setListViewName(updatedListViewNames);
        }
        setIsNewView(false);
    };
    var cancelViewname = function () {
        //logic for canceling the selected view name
        getViewNameListSettingsSelected();
    };
    var handleMoreView = function () {
        setIsMoreViewClicked(!isMoreViewClicked);
    };
    var handleSaveChoice = function () {
        setIsSaveChoice(!isSaveChoice);
    };
    var saveView = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, indexModule, tempNewArray, newDataArray, finalBody, result, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    payload = (_a = {},
                        _a[module] = listViewSettings,
                        _a);
                    indexModule = dataList.findIndex(function (item) { return Object.keys(item)[0] === module; });
                    tempNewArray = [];
                    if (indexModule !== -1) {
                        newDataArray = __spreadArray([], dataList, true);
                        newDataArray[indexModule] = payload;
                        tempNewArray = newDataArray;
                    }
                    else {
                        tempNewArray = __spreadArray(__spreadArray([], dataList, true), [payload], false);
                    }
                    finalBody = { viewlist_settings: tempNewArray };
                    return [4 /*yield*/, saveUserPreferences({
                            body: finalBody,
                        }).unwrap()];
                case 1:
                    result = _b.sent();
                    if (result) {
                        toast.success(t("app.LBL_VIEW_SAVED"));
                    }
                    if (viewname === defaultViewname) {
                        setIsEdited(false);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    toast.error(t("app.LBL_FILTER_NOT_SAVED"));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var incrementNumberInString = function (str) {
        console.log(str);
        var hasCopie = str.includes("(");
        var new_str = !hasCopie ? str + "(0)" : str;
        console.log("new_str : ", new_str);
        return new_str.replace(/\((\d+)\)$/, function (match, p1) {
            // Parse the number, increment it, and return the new string
            var number = parseInt(p1, 10);
            number += 1;
            return "(".concat(number, ")");
        });
    };
    var handleCancelView = function () {
        var _a;
        getViewListSettings();
        getViewNameListSettings();
        getViewNameListSettingsSelected();
        var moduleObject = dataList.find(function (item) { return item[module]; });
        var newSelected = (_a = moduleObject === null || moduleObject === void 0 ? void 0 : moduleObject[module]) === null || _a === void 0 ? void 0 : _a.find(function (item) {
            if (item.id === selectedListView.id) {
                return item;
            }
        });
        newSelected && displayConfig(newSelected === null || newSelected === void 0 ? void 0 : newSelected.config);
    };
    var handleSaveCopieView = function () { return __awaiter(void 0, void 0, void 0, function () {
        var copyName, isViewNameAlreadyExists, arrayCopyNameExist, shouldaddNewView, hasCopieWord;
        var _a;
        return __generator(this, function (_b) {
            if (viewname === defaultViewname) {
                toast.error(t("app.LBL_UNABLE_TO_SAVE"));
                return [2 /*return*/];
            }
            setIsClicked(true);
            copyName = viewname;
            isViewNameAlreadyExists = listViewSettings.some(function (setting) { return setting.viewname === copyName; });
            arrayCopyNameExist = listViewSettings.filter(function (setting) {
                return setting.viewname.startsWith("".concat(t("app.LBL_COPY_OF"), " <").concat(selectedListView.viewname, ">"));
            });
            shouldaddNewView = isViewNameAlreadyExists;
            if (shouldaddNewView) {
                hasCopieWord = selectedListView.viewname.includes(t("app.LBL_COPY_OF") + " <");
                copyName = hasCopieWord
                    ? incrementNumberInString(viewname)
                    : arrayCopyNameExist.length > 0
                        ? "".concat(incrementNumberInString((_a = arrayCopyNameExist[arrayCopyNameExist.length - 1]) === null || _a === void 0 ? void 0 : _a.viewname))
                        : "".concat(t("app.LBL_COPY_OF"), " <").concat(selectedListView.viewname === ""
                            ? viewname
                            : selectedListView.viewname, ">");
                setViewname(copyName);
            }
            addNewView(true, copyName);
            toast.success(t("app.LBL_SAVE_VIEW_COPY"));
            return [2 /*return*/];
        });
    }); };
    var deleteView = function (itemId, itemLabel) {
        if (itemLabel === viewname) {
            setViewname(defaultViewname);
        }
        setListViewSettings(listViewSettings.filter(function (item) { return item.id !== itemId; }));
        setListViewName(listViewName.filter(function (item) { return item.id !== itemId; }));
    };
    var deleteViewFromSaveConfig = function () {
        if (viewname !== defaultViewname) {
            deleteView(selectedListView.id, selectedListView.viewname);
            toast.success(t("app.LBL_VIEW_DELETED"));
        }
        resetConfig();
    };
    var handleDeleteView = function (e, itemView) {
        e.stopPropagation();
        deleteView(itemView.id, itemView.label);
    };
    var determineIcon = function (value) {
        if (value === "savecopie") {
            return faCopy;
        }
        else if (value === "cancelmodif") {
            return faUndo;
        }
        else {
            return faTrash;
        }
    };
    var handleSaveSettings = function (item) {
        setsaveViewname(item.label);
        setIsSaveChoice(false);
        if (item.value === "savecopie") {
            handleSaveCopieView();
        }
        else if (item.value === "cancelmodif") {
            handleCancelView();
        }
        else {
            deleteViewFromSaveConfig();
        }
    };
    var focusInput = function () {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };
    var addNewView = function (isCopy, copyName) {
        if (isCopy === void 0) { isCopy = false; }
        if (copyName === void 0) { copyName = ""; }
        focusInput();
        displayConfig(initialConfigRef === null || initialConfigRef === void 0 ? void 0 : initialConfigRef.current);
        onPageChange(0);
        var identifier = id;
        var newView = {
            id: identifier,
            viewname: "",
            config: config,
            selected: false,
        };
        if (isCopy) {
            newView = {
                id: identifier,
                viewname: copyName,
                config: config,
                selected: false,
            };
            if (selectedListView) {
                displayConfig(selectedListView === null || selectedListView === void 0 ? void 0 : selectedListView.config);
                onPageChange(selectedListView === null || selectedListView === void 0 ? void 0 : selectedListView.config.paginations.currentPage);
            }
            setListViewName(__spreadArray(__spreadArray([], listViewName, true), [{ id: identifier, label: copyName }], false));
            setListViewSettings(function (prevSettings) { return __spreadArray(__spreadArray([], (prevSettings || []), true), [
                newView,
            ], false); });
            setSelectedListView(newView);
        }
        else {
            setViewname("");
            setIsMoreViewClicked(false);
            setIsNewView(true);
            setListViewName(__spreadArray(__spreadArray([], listViewName, true), [{ id: identifier, label: "" }], false));
            //add the newview to listViewSettings
            setListViewSettings(function (prevSettings) { return __spreadArray(__spreadArray([], (prevSettings || []), true), [
                newView,
            ], false); });
        }
    };
    useEffect(function () {
        if (isNewView && listViewSettings) {
            var selectedListViewSettings = listViewSettings[listViewSettings.length - 1];
            setSelectedListView(selectedListViewSettings);
        }
    }, [listViewSettings, module]);
    var updateView = function (value, id) {
        setViewname(value);
        setIsMoreViewClicked(false);
        setIsEdited(true);
        var updatedListViewSettings = listViewSettings.map(function (item) {
            if (item.id === id) {
                return __assign(__assign({}, item), { selected: true });
            }
            else {
                return __assign(__assign({}, item), { selected: false });
            }
        });
        var selectedListViewSettings = updatedListViewSettings.find(function (item) { return item.id === id; });
        displayConfig(selectedListViewSettings === null || selectedListViewSettings === void 0 ? void 0 : selectedListViewSettings.config);
        onPageChange(selectedListViewSettings === null || selectedListViewSettings === void 0 ? void 0 : selectedListViewSettings.config.paginations.currentPage);
        setSelectedListView(selectedListViewSettings);
        setIsNewView(false);
    };
    useEffect(function () {
        if (selectedListView &&
            listViewSettings &&
            listViewSettings.length > 0 &&
            viewname !== defaultViewname) {
            var updatedListViewSettings = listViewSettings.map(function (item) {
                if (item.id === selectedListView.id) {
                    return __assign(__assign({}, item), { config: config, selected: true });
                }
                return __assign(__assign({}, item), { selected: false });
            });
            // Update listViewSettings only if there's a change
            if (JSON.stringify(updatedListViewSettings) !==
                JSON.stringify(listViewSettings)) {
                setListViewSettings(updatedListViewSettings);
            }
        }
    }, [config, selectedListView, listViewSettings, module]);
    var isViewListAlreadyExists = function (value) {
        if (value === "") {
            return false;
        }
        var result = listViewSettings.some(function (setting) { return setting.viewname === value; });
        if (result || viewname === defaultViewname) {
            return true;
        }
        else {
            return false;
        }
    };
    var handleViewName = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setViewname(value);
            return [2 /*return*/];
        });
    }); };
    var handleClickOutside = function (event) {
        if (dropdownInputRef.current &&
            !dropdownInputRef.current.contains(event.target)) {
            setIsMoreViewClicked(false);
        }
        if (dropdownSaveRef.current &&
            !dropdownSaveRef.current.contains(event.target)) {
            setIsSaveChoice(false);
        }
    };
    useEffect(function () {
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var resetConfig = function () {
        var _a;
        displayConfig(initialConfigRef === null || initialConfigRef === void 0 ? void 0 : initialConfigRef.current);
        onPageChange(0);
        setViewname(defaultViewname);
        var moduleObject = dataList.find(function (item) { return item[module]; });
        var updatedListViewSettings = (_a = moduleObject === null || moduleObject === void 0 ? void 0 : moduleObject[module]) === null || _a === void 0 ? void 0 : _a.map(function (item) {
            if (item.selected === true) {
                return __assign(__assign({}, item), { selected: false });
            }
            return item;
        });
        setListViewSettings(updatedListViewSettings);
    };
    var isConfigChanged = function () {
        var moduleObject = dataList.find(function (item) { return item[module]; });
        if (!moduleObject)
            return false;
        var matchingItem = moduleObject[module].find(function (item) { return item.id === (selectedListView === null || selectedListView === void 0 ? void 0 : selectedListView.id); });
        if (!matchingItem)
            return false;
        var configListMatched = listViewSettings.find(function (item) { return item.id === (selectedListView === null || selectedListView === void 0 ? void 0 : selectedListView.id); });
        // Assuming matchingItem and configListMatched are objects with properties to compare
        return JSON.stringify(matchingItem) !== JSON.stringify(configListMatched);
    };
    var isConfigListChanged = function () {
        var moduleObject = dataList.find(function (item) { return item[module]; });
        // Check if moduleObject is undefined
        if (!moduleObject) {
            // Handle the case when moduleObject is not found
            if ((listViewSettings === null || listViewSettings === void 0 ? void 0 : listViewSettings.length) > 0) {
                return true;
            }
            return false;
        }
        var moduleList = moduleObject[module];
        // Ensure moduleList is valid
        if (!moduleList) {
            if (listViewSettings.length > 0) {
                return true;
            }
            return false;
        }
        // Compare the elements of the two arrays directly
        if (JSON.stringify(moduleList) !== JSON.stringify(listViewSettings)) {
            return true;
        }
        else {
            return false;
        }
    };
    var _s = useState(false), configHasChanged = _s[0], setConfigHasChanged = _s[1];
    var _t = useState(false), configListHasChanged = _t[0], setConfigListHasChanged = _t[1];
    useEffect(function () {
        var hasChanged = isConfigChanged();
        var hasListChanged = isConfigListChanged();
        setConfigHasChanged(hasChanged);
        setConfigListHasChanged(hasListChanged);
    }, [dataList, listViewSettings, selectedListView, module]);
    useEffect(function () {
        setConfigHasChanged(false);
    }, [selectedListView, module]); // Reset when selectedListView changes
    var _u = useState(false), showButton = _u[0], setShowButton = _u[1];
    useEffect(function () {
        // Delay showing the button for 3 second after component mounts
        var timer = setTimeout(function () {
            setShowButton(true);
        }, 3000);
        // Clear the timer if the component unmounts
        return function () { return clearTimeout(timer); };
    }, []);
    var navigate = useNavigate();
    return (_jsxs("div", __assign({ className: "flex w-full flex-row items-center justify-center space-x-2 text-[rgb(var(--color-gray-400))] font-medium z-[6] " }, { children: [_jsxs("div", __assign({ className: "flex w-full flex-row mx-2 justify-center items-center" }, { children: [_jsx(FontAwesomeIcon, { icon: faSuitcase, className: "mx-2" }), _jsxs("div", __assign({ className: "flex items-center cursor-pointer" }, { children: [_jsx("span", { children: t("LBL_MODULE_TITLE", { ns: module }) }), _jsx(_Fragment, { children: _jsx(FontAwesomeIcon, { icon: faPlus, title: String(t("app.LBL_CREATE_BUTTON_LABEL")), className: "mx-2", onClick: function () { return navigate("/modules/".concat(module, "/EditView")); } }) })] })), _jsxs("div", __assign({ className: "flex w-full text-[rgb(var(--color-gray-500))] mx-1 items-center ", onMouseOver: function () {
                            focusInput();
                            setIsLabelViewOnOver(true);
                        }, onMouseLeave: function () { return setIsLabelViewOnOver(false); } }, { children: [isClicked ? (_jsxs("div", __assign({ ref: dropdownInputRef, className: "flex w-full flex-row bg-white px-2 justify-center items-center relative" }, { children: [_jsxs(_Fragment, { children: [_jsx(FontAwesomeIcon, { icon: isMoreViewClicked ? faCaretDown : faCaretRight, onClick: handleMoreView, className: "cursor-pointer" }), isMoreViewClicked && (_jsxs("div", __assign({ className: "z-[2] absolute top-8 left-0 mt-1 w-full bg-white border border-gray-200 shadow-lg rounded-md" }, { children: [_jsxs("ul", __assign({ className: "".concat((listViewName === null || listViewName === void 0 ? void 0 : listViewName.length) >= 8 && "h-80 overflow-auto") }, { children: [_jsx("li", __assign({ onClick: function () {
                                                                    resetConfig();
                                                                    setIsClicked(false);
                                                                }, className: "flex items-center justify-between px-4 py-2 cursor-pointer hover:text-blue-600 ".concat(viewname === defaultViewname && "bg-gray-50") }, { children: defaultViewname })), listViewName
                                                                .slice()
                                                                .reverse()
                                                                .map(function (item, index) { return (_jsxs("li", __assign({ onClick: function () {
                                                                    updateView(item.label, item.id);
                                                                }, className: "flex items-center justify-between px-4 py-2 cursor-pointer hover:text-blue-600 ".concat(item.label === viewname && "bg-blue-50") }, { children: [_jsx("span", __assign({ className: "flex-1 ".concat(item.label
                                                                            ? ""
                                                                            : " italic text-gray-400 text-sm") }, { children: item.label
                                                                            ? item.label
                                                                            : "[" + t("app.LBL_ADD_VIEW_NAME") + "]" })), _jsx(FontAwesomeIcon, { icon: faTrash, onClick: function (e) { return handleDeleteView(e, item); }, style: { cursor: "pointer" }, color: "var(--color-red-600)", className: "hover:text-[rgb(var(--color-red-500))]" })] }), index)); })] })), _jsxs("div", __assign({ className: "py-1" }, { children: [_jsx("hr", { className: "border-t border-gray-200" }), _jsx("span", __assign({ className: "block px-4 py-2 flex-1 hover:bg-gray-50 text-[rgb(var(--color-violet-700))] font-medium cursor-pointer", onClick: function () {
                                                                    addNewView();
                                                                } }, { children: t("app.LBL_NEW_VIEW") }))] }))] })))] }), _jsx("input", { value: viewname, onChange: function (e) { return handleViewName(e.target.value); }, onClick: function (e) { return e.stopPropagation(); }, onKeyDown: function (e) {
                                            if (e.key === "Enter") {
                                                validateViewname();
                                            }
                                            else if (e.key === "Escape") {
                                                cancelViewname();
                                            }
                                        }, style: {
                                            border: "none",
                                            boxShadow: "none",
                                            width: "235px",
                                            padding: "5px",
                                        }, className: "flex  mx-1 p-1   ".concat(viewname === defaultViewname
                                            ? " cursor-not-allowed focus:outline-none"
                                            : "bg-white border border-gray-300 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50"), readOnly: viewname === defaultViewname, ref: inputRef }), _jsx(FontAwesomeIcon, { icon: faCheck, className: "mx-2 cursor-pointer", color: "var(--color-green-500)", onClick: validateViewname }), _jsx(FontAwesomeIcon, { icon: faUndo, className: "red cursor-pointer", color: "var(--color-red-600)", onClick: cancelViewname })] }))) : (_jsxs(_Fragment, { children: [_jsx(FontAwesomeIcon, { onClick: function () {
                                            setIsClicked(true);
                                            setIsMoreViewClicked(true);
                                            setIsEdited(true);
                                        }, icon: faCaretRight, className: "mx-2 cursor-pointer" }), viewname ? (viewname) : (_jsxs("span", __assign({ className: " italic text-gray-400 text-sm" }, { children: ["[", t("app.LBL_ADD_VIEW_NAME"), "]"] })))] })), isLabelViewOnOver && (_jsx(_Fragment, { children: _jsx(FontAwesomeIcon, { icon: faPencil, className: "mx-2 cursor-pointer ".concat(isClicked && "hidden"), onClick: function () {
                                        setIsClicked(true);
                                        setIsEdited(true);
                                    } }) }))] }))] })), showButton &&
                (configHasChanged || configListHasChanged || isEdited) &&
                !isNewView && (_jsx("div", __assign({ ref: dropdownSaveRef, className: "" }, { children: _jsxs(Button, __assign({ onClick: !isEdited || viewname === defaultViewname
                        ? saveView
                        : handleSaveCopieView, sx: {
                        backgroundColor: "white",
                        color: !isEdited
                            ? "var(--color-red-700)"
                            : "var(--color-gray-500)",
                        "&:hover": {
                            backgroundColor: "gray",
                            color: "white",
                        },
                        width: !isEdited ? "200px" : "250px",
                        boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.1)",
                    } }, { children: [_jsx(FontAwesomeIcon, { icon: !isEdited || viewname === defaultViewname ? faSave : faCopy, className: "px-1" }), _jsx("span", __assign({ className: "text-gray-400 font-normal text-inherit" }, { children: !isEdited || viewname === defaultViewname
                                ? " " + t("app.LBL_SAVE_VIEW")
                                : listSaveconfig[0].label })), !isEdited && (_jsx(FontAwesomeIcon, { icon: faCaretDown, onClick: function (e) {
                                e.stopPropagation(); // Prevent the button click event
                                handleSaveChoice();
                            }, className: "cursor-pointer mx-1 py-1  hover:scale-110 transition-transform duration-150 ease-in-out", size: "lg" })), isSaveChoice && (_jsx("div", __assign({ className: "z-[2] absolute top-8 left-0 mt-1 w-full bg-white border border-gray-200 shadow-lg rounded-md" }, { children: _jsx("ul", { children: listSaveconfig &&
                                    listSaveconfig.map(function (item, index) { return (_jsxs("li", __assign({ className: "flex items-center justify-between px-4 py-2 cursor-pointer text-[rgb(var(--color-violet-500))] font-normal hover:text-blue-600", onClick: function (e) {
                                            e.stopPropagation();
                                            handleSaveSettings(item);
                                        } }, { children: [_jsx(FontAwesomeIcon, { icon: determineIcon(item.value), style: { cursor: "pointer" }, className: "hover:text-[rgb(var(--color-violet-800))] pr-1 " }), _jsx("span", __assign({ className: "flex-1 " }, { children: item.label }))] }), index)); }) }) })))] })) }))), isLoadSave && _jsx(LoaderImage, {})] })));
};
export default ViewManager;
